<div fxLayout="column" class="container">
  <div class="attribute-code-display">{{ attributeCode.getDisplay() }}</div>
  <num-searchbar icon="search" (searchTextChange)="startElasticSearch($event)"> </num-searchbar>
  <div
    class="infinite-scroll"
    infiniteScroll
    [infiniteScrollDistance]="0.5"
    [infiniteScrollThrottle]="50"
    [scrollWindow]="false"
    (scrolled)="loadMoreCriteriaSetResults()"
  >
    <num-table
      *ngIf="listItems.length > 0 && adaptedData"
      class="result-list-container"
      [tableData]="adaptedData"
      [searchTermResultList]="listItems"
      (selectedRow)="setSelectedRowItem($event)"
    ></num-table>
  </div>
  <num-placeholder-box class="no-results-text" *ngIf="!searchResultsFound"
    >{{ 'FEASIBILITY.SEARCH.EMPTY' | translate }} "<strong>{{ searchText$ | async }}</strong
    >"</num-placeholder-box
  >
  <button
    *ngIf="isTableItemsSelected"
    mat-raised-button
    class="add-button"
    color="white"
    (click)="setSelectedReferenceCriteria()"
  >
    {{ 'FEASIBILITY.EDITOR.REFERENCE.ADD' | translate }}
  </button>
  <div *ngIf="arrayOfSelectedReferences.length > 0" class="filter-selection">
    <div class="filter-title">{{ 'FEASIBILITY.EDITOR.REFERENCE.SELECTION' | translate }}</div>
    <div class="selectedFilterBox">
      <div
        *ngFor="let selectedReferences of arrayOfSelectedReferences; let index = index"
        fxLayout="row"
        fxLayoutAlign="start center"
        class="selectedFilter"
      >
        <div
          matTooltipPosition="below"
          matTooltipShowDelay="300"
          [matTooltip]="selectedReferences.display | displayTranslation"
          fxFlex="50"
          class="display-part"
        >
          {{ selectedReferences.display | displayTranslation }}
        </div>
        <div fxFlex="50" class="display-part">
          {{ selectedReferences.terminology }} ({{ selectedReferences.system }})
        </div>
        <div fxFlexAlign="end">
          <button (click)="removeSelectedReference(index)" class="delete-button">entfernen</button>
        </div>
      </div>
    </div>
  </div>
</div>
